import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { fetchTeams } from "../../../../api/businessAndEnterprise/driveApi";
import { FiFileText, FiUsers } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Context from "../../../../context/Context";

const TeamDrive = () => {
    const [teams, setTeams] = useState([]);
    const [teamsTotalCount, setTeamTotalCount] = useState(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const { setPageTitle } = useContext(Context);

    const loaderRef = useRef(null);
    const navigate = useNavigate();

    const fetchTeamsList = (page = 1) => {
        if (loading) return;
        setLoading(true);

        fetchTeams({ page: page }, (response) => {
            if (response?.status === true) {
                setTeams(response?.data);
                setTeamTotalCount(response?.count);
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchTeamsList();
    }, []);

    useEffect(() => {
        setPageTitle('My Teams');

    }, [teamsTotalCount, setPageTitle]);


    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (target.isIntersecting && !loading) {
                if (teams?.length < teamsTotalCount) {
                    const nextPage = page + 1;
                    setPage(page);
                    fetchTeamsList(nextPage);
                }
            }
        },
        [loading, page, teams.length, teamsTotalCount]
    );

    useEffect(() => {
        const option = { root: null, rootMargin: "20px", threshold: 1.0 };
        const observer = new IntersectionObserver(handleObserver, option);

        if (loaderRef.current) observer.observe(loaderRef.current);

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [handleObserver]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
        );
    }
    return (
        <div>
            <div className="bg-white p-4 rounded-xl ">

                {teams?.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 cursor-pointer">
                        {teams?.map((team, idx) => (
                            <div
                                key={idx}
                                className="border rounded-xl shadow-md p-3 sm:p-4 hover:shadow-xl transition bg-white flex flex-col justify-between h-[108px]"
                                onClick={() => navigate(`/teams/${team?.id}/drive`)}
                            >
                                <p className="font-bold text-xl sm:text-base mb-3 break-words">
                                    {team?.name}
                                </p>

                                <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm text-gray-600">
                                    <div className="flex items-center gap-1 min-w-fit">
                                        <FiUsers className="h-4 w-4 text-gray-500 shrink-0" />
                                        <span className="truncate">{team?.total_members} Members</span>
                                    </div>

                                    <div className="flex items-center gap-1 min-w-fit">
                                        <FiFileText className="h-4 w-4 text-gray-500 shrink-0" />
                                        <span className="truncate">{team?.total_shared_sheets} Sheets</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                ) : (
                    <div className="text-center ">
                        <p className="text-black font-bold">No teams yet</p>
                        <p className="text-gray-500 text-xs sm:text-sm">
                            Your teams will appear here as soon as you create them.
                        </p>
                    </div>
                )}

                {(teams?.length < teamsTotalCount) && (
                    <div ref={loaderRef} className="flex justify-center py-4">
                        <span className="text-gray-500">Loading more...</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TeamDrive;